import React, { useEffect, useCallback, useState } from "react";
import { requestData } from "../services/requests";
import {Menu} from "lucide-react"
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';
import DownloadCarteiras from "./downloadCarteira";
const { criarCarteiras, apiForImages, apiUrl } = require('../services/requests');


const VisualizarCarteirasMobile = () => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const url_atual = window.location.href;
    const id = url_atual.split('/')[4];
    const [carteira, setCarteira] = useState({});
    const [gestorResponsavel, setGestor] = useState({});
    const date = new Date();
    const newDate = moment(date).locale('pt-br').format('YYYY-MM-DD HH:mm:ss');
    const dataValidade = new Date(date.getFullYear() + 1, 2, 31);
    const MensagemWhatsAppAjuda = `https://api.whatsapp.com/send?phone=${gestorResponsavel.telefone}&text=Olá,`
        + `Gostaria de informações sobre a Carteira nº ${carteira.codigoUso}`
    const mensagemRenovacao = `https://api.whatsapp.com/send?phone=${gestorResponsavel.telefone}&text=Olá,`
        + `Gostaria de solicitar a renovação da carteira nº ${carteira.codigoUso}`;

    const [componenteRenderizado, setComponenteRenderizado] = useState(false);

    const redirecionarParaOutraPagina = () => {
        window.location.href = MensagemWhatsAppAjuda;
    };

    const handleClickRenovar = async (e) => {
        if (!user) {
            window.location.href = mensagemRenovacao;
        }

        handleClick(e);
    }

    const handleClickDownload = async () => {
        setComponenteRenderizado(true);
    }


    const handleClick = async (e) => {
        e.preventDefault();
        if (user) {
            try {
                const endpoint = '/carteiras/renovacao';
                await criarCarteiras(endpoint, {
                    foto: carteira.foto,
                    codigoUso: carteira.codigoUso,
                    nome: carteira.name,
                    instituicaoEnsino: carteira.instituicaoEnsino,
                    curso: carteira.curso,
                    cpf: carteira.cpf,
                    rg: carteira.rg,
                    dataNascimento: carteira.dataNascimento,
                    dataValidade,
                    dataEmissao: newDate,
                    email: carteira.email,
                    telefone: carteira.telefone,
                });
                navigate('/painel');
            } catch (error) {
                console.log(error);
            }
        }
    }

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const getCarteira = useCallback(async () => {
        const carteiras = await requestData(`/carteiras/${id}`);
        setCarteira(carteiras);
        setGestor(carteiras.gestorResponsavel);
    }, [id]);

    useEffect(() => {
        getCarteira();
    }, [getCarteira]);

    return (
        <>
            {(componenteRenderizado) ? <DownloadCarteiras carteira={carteira} setComponenteRenderizado={setComponenteRenderizado} />
                :
                <div className={`relative max-full mx-auto p-0 ${isOpen ? 'overflow-hidden' : ''}`}>
                    <header className="relative flex items-center justify-center h-16 w-full bg-blue-600 px-4">
                        <div className="flex items-center h-full">
                            <img src={`${apiForImages}/images/logo_unisc.png`} alt="logo" className="w-[120px] sm:w-[140px] lg:w-[160px]" />
                        </div>
                        
                        <button className="absolute right-4 text-white cursor-pointer z-50 p-2  rounded-lg transition-colors hover:bg-blue-500" onClick={toggleMenu}> 
                            <Menu size={24} />
                        </button>
                        
                        <ul id="menu" className={`z-50 list-none flex items-center justify-center m-0 p-0 absolute top-16 w-full bg-gray-100 transition-all duration-500 ease-in-out ${isOpen ? 'max-h-52 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
                            <li className="inline-block mb-2.5">
                                {carteira.status === 'Cancelada' || carteira.status === 'Expirada' ?
                                    <button
                                        className="m-5 h-10 w-32 rounded-2xl text-white bg-red-600 border-none hover:text-gray-600"
                                        onClick={(e) => handleClickRenovar(e)}
                                        style={{fontSize: '3vw'}}
                                    > RENOVAR </button> :
                                    carteira.status === 'Validada' ?
                                        <button className="m-5 h-10 w-32 rounded-2xl text-white bg-yellow-500 border-none hover:text-gray-600"
                                            onClick={handleClickDownload}
                                            style={{fontSize: '3vw'}}> DOWNLOAD </button> :
                                        carteira.status === 'Recepcionada' && null
                                }
                            </li>
                            <li className="inline-block mb-2.5">
                                <button className="m-5 h-10 w-32 rounded-2xl text-white bg-blue-600 border-none hover:text-gray-600" 
                                    onClick={redirecionarParaOutraPagina}
                                    style={{fontSize: '3vw'}}>CONTATO</button>
                            </li>
                        </ul>
                        
                        {/* Overlay do menu */}
                        <div className={`fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 ${isOpen ? 'block' : 'hidden'} z-40`} onClick={toggleMenu}></div>
                    </header>
                    <section className="flex flex-col mt-5">
                        <div className="text-center font-neo-sans-pro font-bold" style={{fontSize: '6vw'}}>
                            <h1> DOCUMENTO NACIONAL DO ESTUDANTE (DNE) </h1>
                        </div>
                        <div className="container_cards mt-10">
                            <div className="flex w-full justify-around items-center">
                                <div className="m-0 p-0 flex items-center justify-center w-1/3 max-h-[300px]">
                                    <img src={carteira.foto} alt="foto" className="w-full max-h-[300px]" />
                                </div>
                                {
                                    carteira.status === 'Validada' ?
                                        <div className='flex flex-col font-neo-sans-pro font-medium text-center mr-5' style={{fontSize: '4vw'}}>
                                            <div className="flex flex-col mb-5">
                                                <span className="mb-1">Código de uso</span>
                                                <span className="mb-1">{carteira.codigoUso}</span>
                                            </div>
                                            <div className="flex flex-col">
                                                <span className="mb-1">Validade</span>
                                                <span className="mb-1"> {moment(carteira.dataValidade).locale('pt-br').format('DD/MM/YYYY')}</span>
                                            </div>
                                        </div> : null
                                }
                            </div>
                            <div className="flex flex-col m-8">
                                <div className="ml-8 flex flex-col mb-8">
                                    <div className="mb-0.5 flex flex-col">
                                        <span className="font-neo-sans-pro mb-0" style={{fontSize: '4vw'}}>Nome:</span>
                                        <span className="my-0.5 font-neo-sans-pro font-medium" style={{fontSize: '5vw'}}>{carteira.name}</span>
                                    </div>
                                    <div className="mb-0.5 flex flex-col">
                                        <span className="font-neo-sans-pro mb-0" style={{fontSize: '4vw'}}>Instituição de ensino:</span>
                                        <span className="my-0.5 font-neo-sans-pro font-medium" style={{fontSize: '5vw'}}>{carteira.instituicaoEnsino}</span>
                                    </div>
                                    <div className="mb-0.5 flex flex-col">
                                        <span className="font-neo-sans-pro mb-0" style={{fontSize: '4vw'}}>Curso:</span>
                                        <span className="my-0.5 font-neo-sans-pro font-medium" style={{fontSize: '5vw'}}>{carteira.curso}</span>
                                    </div>
                                    <div className="mb-0.5">
                                        <span className="font-neo-sans-pro mb-0" style={{fontSize: '4vw'}}>CPF: </span>
                                        <span className="my-0.5 font-neo-sans-pro font-medium" style={{fontSize: '5vw'}}>{carteira.cpf}</span>
                                    </div>
                                    <div className="mb-0.5">
                                        <span className="font-neo-sans-pro mb-0" style={{fontSize: '4vw'}}>RG: </span>
                                        <span className="my-0.5 font-neo-sans-pro font-medium" style={{fontSize: '5vw'}}>{carteira.rg}</span>
                                    </div>
                                    <div className="mb-0.5">
                                        <span className="font-neo-sans-pro mb-0" style={{fontSize: '4vw'}}>Data Nasc: </span>
                                        <span className="my-0.5 font-neo-sans-pro font-medium" style={{fontSize: '5vw'}}>{carteira.dataNascimento}</span>
                                    </div>
                                </div>
                                {
                                    carteira.status === 'Validada' ?
                                        <button className="self-center border-none bg-green-200 font-neo-sans-pro font-medium h-10 w-1/2 rounded-2xl text-green-700 sm:h-16" style={{fontSize: '4vw'}}>Carteira Válida!</button>
                                        : carteira.status === 'Cancelada' || carteira.status === 'Expirada' ?
                                            <button className="self-center border-none bg-red-300 font-neo-sans-pro font-medium h-10 w-1/2 rounded-2xl text-red-700 sm:h-16" style={{fontSize: '4vw'}}>Expirada!</button>
                                            : carteira.status === 'Recepcionada' &&
                                            <button className="self-center border-none bg-blue-300 font-neo-sans-pro font-medium h-10 w-1/2 rounded-2xl text-blue-600 sm:h-16" style={{fontSize: '4vw'}}>Recepcionada!</button>
                                }
                            </div>
                        </div>
                    </section>
                    <footer className="bg-gray-200 flex flex-col items-center justify-center">
                        <div className="mt-4">
                            <h3 className="font-inter font-medium mb-1" style={{fontSize: '2vw'}}> UNISC ESTUDANTIL </h3>
                        </div>
                        <div className="flex flex-col justify-center items-center w-3/5">
                            <span className="text-center font-inter font-semibold mb-1" style={{fontSize: '1.5vw'}}>
                                UNIAO ESTUDANTIL NACIONAL DE INCENTIVO
                                SOCIAL E CULTURAL
                            </span>
                            <span className="text-center font-inter font-semibold mb-1" style={{fontSize: '1.5vw'}}>CNPJ: 31.370.444/0001-42</span>
                        </div>
                        <div className="mb-5">
                            <span className="font-inter font-medium" style={{fontSize: '1.8vw'}}>uniscestudantil@gmail.com</span>
                        </div>
                    </footer>
                </div>
            }
        </>
    )
}

export default VisualizarCarteirasMobile;
